const isPDP = window.location.pathname.includes("/products/");
if (isPDP) {
    let oldHref = location.href;
    new MutationObserver(() => {
        if (oldHref !== location.href) {
            oldHref = location.href;
            const variant = new URL(location.href).searchParams.get('variant');
            setTimeout(() => {
                const productForm = document.querySelector("[bss-b2b-main-product-form]");
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                    productForm
                });
            }, 600)
        }
    }).observe(document, {
        subtree: true,
        childList: true
    });
}

// SBCB2BBS-4859: Quote's fetch add-to-cart bypasses Venue's jQuery form handler.
// Reload Venue's drawer and cart count after successful same-store additions.
(() => {
    if (window.__bssCartDrawerSync || typeof window.fetch !== 'function') return;
    window.__bssCartDrawerSync = true;

    const originalFetch = window.fetch;
    let reloadTimer;

    function isCartAdd(input) {
        try {
            const value = typeof input === 'string' || input instanceof URL
                ? input
                : input?.url;
            if (!value) return false;
            const url = new URL(value, window.location.href);
            return url.origin === window.location.origin &&
                /\/cart\/add(?:\.js|\.json)?\/?$/.test(url.pathname);
        } catch {
            return false;
        }
    }

    function reloadCartUI(attempt = 0) {
        clearTimeout(reloadTimer);
        reloadTimer = setTimeout(() => {
            if (typeof window.ajaxCart?.load === 'function') {
                window.ajaxCart.load();
            } else if (attempt < 20) {
                // A successful request can finish before Venue initializes.
                reloadCartUI(attempt + 1);
            }
        }, 150);
    }

    window.fetch = function (...args) {
        const request = originalFetch.apply(this, args);
        if (isCartAdd(args[0])) {
            request.then(response => {
                if (response.ok) reloadCartUI();
            }).catch(() => {});
        }
        // Preserve the response and error handling used by the app.
        return request;
    };
})();
